// src/store/flowSlice.js
import { createSlice } from '@reduxjs/toolkit';

// Check if the URL contains the 'redirected' parameter
const urlParams = new URLSearchParams(window.location.search);
const isRedirected = urlParams.has('redirected'); // Check if 'redirected' is in the URL

// If 'redirected' parameter is present, load from sessionStorage, otherwise use defaults
const savedFlow = isRedirected ? sessionStorage.getItem('flow') : '';
const savedFormData = isRedirected ? JSON.parse(sessionStorage.getItem('formData')) : {};
const savedPickupRequired = isRedirected ? JSON.parse(sessionStorage.getItem('pickupRequired')) : true;

//console.log('savedFlow:', savedPickupRequired, 'isRedirected:', isRedirected);

const initialState = {
  activeFlow: savedFlow || '', // If flow exists in sessionStorage and 'redirected' is present, set it, otherwise default to ''
  currentStep: savedFlow ? 1 : 0, // If flow exists, set step to 1
  formData: savedFormData || {}, // If formData exists and 'redirected' is present, initialize with it
  pickupRequired: savedPickupRequired, // If pickupRequired exists and 'redirected' is present, initialize with it
};

const flowSlice = createSlice({
  name: 'flow',
  initialState,
  reducers: {
    setActiveFlow(state, action) {
      state.activeFlow = action.payload;
      // Save activeFlow to sessionStorage
      sessionStorage.setItem('flow', action.payload);
    },
    setCurrentStep(state, action) {
      state.currentStep = action.payload;
    },
    setIsPickupRequired(state, action) {
      state.pickupRequired = action.payload;
      sessionStorage.setItem('pickupRequired', action.payload);
    },
    setFormData(state, action) {
      // Append new form data while preserving existing data
      state.formData = {
        ...state.formData,
        ...action.payload
      };
      // Save formData to sessionStorage
      sessionStorage.setItem('formData', JSON.stringify(state.formData));
    },
  },
});

export const {
  setActiveFlow,
  setCurrentStep,
  setIsPickupRequired,
  setFormData
} = flowSlice.actions;

export default flowSlice.reducer;